var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-x flex-grow"},[_c('div',{staticClass:"cell auto cell-block-y flex flex-col flex-grow"},[_c('Loading',{attrs:{"loading":_vm.waitPending}},[_c('div',{staticClass:"flex flex-col"},[_c('Table',{attrs:{"columns":_vm.columns,"rows":_vm.payload,"sort-options":{
            enabled: false,
          },"busy":_vm.waitPending}})],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }